import { EmailLockIcon } from './EmailLockIcon';

/**
 * author: Simran
 * id 04288F6D-7E3C-4BB6-8FDE-B8951C0D0BDF
 * name email-lock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-lock.svg
 * tags
 * - Lock 
 */
export const EnvelopeSecureIcon = EmailLockIcon;
export default EnvelopeSecureIcon